module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/wifi-6-b5173c34a493f63af69998a5d7013123.jpeg";